import { createFileRoute, notFound, redirect } from "@tanstack/react-router";
import giftStyles from "../styles/gifts.css?url";
import { MyGifts } from "../components/membership/gift-pages";
import { creatorPageHead, shellFrom, withStylesheet } from "../lib/head";
import { keepSearch, searchText } from "../lib/search";
import { loadMyGifts } from "../server/gifts";

/** The gifts a member bought on this site (/account/gifts), where checkout returns. Private. */
export const Route = createFileRoute("/account_/gifts")({
  validateSearch: keepSearch,
  loaderDeps: ({ search }) => ({
    gift: searchText(search, "gift"),
    checkout: searchText(search, "checkout"),
  }),
  loader: async ({ deps }) => {
    const data = await loadMyGifts({ data: deps });
    if (data.kind === "missing") throw notFound();
    if (data.kind === "redirect") throw redirect({ href: data.to, statusCode: 302 });
    return data;
  },
  head: ({ matches, loaderData }) => {
    const shell = shellFrom(matches);
    if (!shell || !loaderData) return {};
    return withStylesheet(
      creatorPageHead(shell, {
        pathname: "/account/gifts",
        title: `Your gifts | ${loaderData.creatorName}`,
        description: `Memberships you've given on ${loaderData.creatorName}.`,
        noindex: true,
      }),
      giftStyles,
    );
  },
  component: Gifts,
});

function Gifts() {
  const data = Route.useLoaderData();
  const search = Route.useSearch();
  return (
    <MyGifts
      creatorName={data.creatorName}
      gifts={data.gifts}
      offered={data.offered}
      highlight={searchText(search, "gift") ?? ""}
    />
  );
}
